import React, { Fragment } from 'react';

import useClubLegalEntities from './UseClubLegalEntities';

import ClubLegalEntitiesReadGrid from './ClubLegalEntitiesReadGrid';
import Headings from '@usas/ui-web/components/headings/Headings';
import PopUpModal from '@usas/ui-web/components/dialogs/PopUpModal';
import Constants from '@usas/ui-web/utils/Constants';

const ClubLegalEntitiesRead = () => {
  const { baseUsasClubState } = useClubLegalEntities();

  return (
    <Fragment>
      <div className="row">
        <div className="col-xs-12">
          <Headings.H3>Club Legal Entities</Headings.H3>
        </div>
      </div>
      <div className="row">
        <div className="col-xs-12 usas-extra-top-margin usas-extra-bottom-margin">
          <ClubLegalEntitiesReadGrid state={baseUsasClubState} />
        </div>
      </div>
      <PopUpModal
        widthPct={50}
        maxWidth={250}
        title={Constants.LOADING_MSG}
        displayPopUp={baseUsasClubState.isObjLoading} />
    </Fragment>
  );
};

export default ClubLegalEntitiesRead;